import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.css']
})
export class TextEditorComponent implements OnInit {

  @Input() readonly = false;
  @Input() label!: string;
  @Input() value!: string;
  @Input() noValue = 'Введите значение';
  @Input() validators: any[] = [];
  @Input() multiline = false;
  @Input() rows = 3;

  @Output() valueChangeEvent = new EventEmitter<string>();

  @ViewChild('input') inputElement!: ElementRef;

  public form!: FormGroup;
  public editMode = false;

  constructor(
    private fb: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      value: [this.value, this.validators],
    });
  }

  setEditMode(value: boolean): void {
    this.editMode = value;
    if (value) {
      setTimeout(() => {
        this.inputElement.nativeElement.focus();
      }, 0);
    }
  }

  onEdit(event: MouseEvent): void {
    event.preventDefault();
    this.setEditMode(true);
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.form.valid) {
      const newValue = this.form.controls.value.value;
      if (this.value !== newValue) {
        this.valueChangeEvent.emit(newValue);
      }
      this.setEditMode(false);
    }
  }

  onCancel(event: MouseEvent): void {
    event.preventDefault();
    this.form.controls.value.setValue(this.value);
    this.setEditMode(false);
  }

}
